var _path, _path2, _g, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSuccessCircularBanner = function SvgSuccessCircularBanner(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 491,
    height: 316,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "success-circular-banner_svg__b",
    width: 361,
    height: 354,
    x: 72,
    y: -120,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#success-circular-banner_svg__a)",
    d: "M72.943-119.792h359.094v353.048H72.943z"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#success-circular-banner_svg__b)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "success-circular-banner_svg__d",
    width: 360,
    height: 354,
    x: 71,
    y: -120,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#success-circular-banner_svg__c)",
    d: "M71.18-119.271h359.094v353.048H71.18z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 1.209,
    mask: "url(#success-circular-banner_svg__d)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 245.89,
    cy: 55.439,
    r: 174.106,
    fill: "#161616",
    stroke: "#2B2B2B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 245.89,
    cy: 55.439,
    r: 158.388,
    fill: "#161616",
    stroke: "#2B2B2B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 245.89,
    cy: 55.439,
    r: 142.67,
    fill: "#161616",
    stroke: "#2B2B2B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 245.89,
    cy: 55.439,
    r: 126.952,
    fill: "#161616",
    stroke: "#2B2B2B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 245.89,
    cy: 55.438,
    r: 111.234,
    fill: "#161616",
    stroke: "#2B2B2B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 245.89,
    cy: 55.439,
    r: 95.516,
    fill: "#161616",
    stroke: "#2B2B2B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 245.89,
    cy: 55.439,
    r: 78.59,
    fill: "#161616",
    stroke: "#2B2B2B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 245.89,
    cy: 55.439,
    r: 62.872,
    fill: "#161616",
    stroke: "#2B2B2B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 245.89,
    cy: 55.439,
    r: 47.154,
    fill: "url(#success-circular-banner_svg__e)",
    stroke: "#2B2B2B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 245.89,
    cy: 55.439,
    r: 32.645,
    fill: "#2B2B2B",
    stroke: "#424242"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 245.891,
    cy: 55.438,
    r: 26.599,
    fill: "#424242",
    stroke: "#5F5F5F"
  })))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.113,
    d: "m237.75 56.709 4.475 4.971 12.429-12.926"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "success-circular-banner_svg__a",
    x1: 252.49,
    x2: 252.49,
    y1: -97.424,
    y2: 168.571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.416,
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.826,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "success-circular-banner_svg__e",
    x1: 245.89,
    x2: 245.89,
    y1: 7.681,
    y2: 103.197,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#272525",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "success-circular-banner_svg__c",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(0 176.524 -179.547 0 250.727 57.253)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })))));
};
export default SvgSuccessCircularBanner;